import { Component, Input, OnInit } from '@angular/core';
import { RowStatus } from '../../../common/enums/row-status.enum';
import { AuthorizationPipe } from '../../../common/pipes/authorization.pipe';
import { IDepartment } from '../../interface/department';
import { DepartmentService } from '../../services/department.service';

@Component({
  selector: 'department-view',
  templateUrl: '../../templates/template1/views/department/department-view.component.html',
  styleUrls: ['../../templates/template1/themes/default/css/department.less'],
  providers: [AuthorizationPipe]
})
export class DepartmentViewComponent implements OnInit {
  @Input() departmentId: number;
  @Input() operatingCountryId: number;
  department: IDepartment;
  ticketTypes: any[];
  rowStatus: any = RowStatus;

  constructor(
    private _departmentService: DepartmentService  ) {
  }

  ngOnInit(): void {
    this.getTicketTypesAndSubTypes();
  }

  /**
   * @description
   * @date 2020-03-05
   * @memberof DepartmentViewComponent
   */
  getTicketTypesAndSubTypes() {
    this._departmentService.getTicketTypesAndSubTypes().subscribe(response => {
      if (response) {
        this.ticketTypes = response;
        this.getDepartmentById(this.departmentId);
      }
    });
  }

  /**
   * @description
   * @date 2020-03-05
   * @param {*} departmentId
   * @memberof DepartmentViewComponent
   */
  getDepartmentById(departmentId: any) {
    this._departmentService.getDepartmentById(departmentId).subscribe(response => {
      if (response) {
        this.department = response;
        this.department.email = this.department.email===null ||this.department.email===undefined || this.department.email===''?'NA':this.department.email;
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/customerservice/components/department/department-view.component.ts